import { FloatingOverlay } from '@floating-ui/react';
import { styled } from '../theme-provider';

export const Overlay = styled(FloatingOverlay)<{ readonly $zIndex?: number }>`
  transition-timing-function: cubic-bezier(0.79, 0.19, 1, 1);
  background-color: rgba(47, 46, 69, 1);
  ${({ $zIndex }) => (typeof $zIndex !== 'undefined' ? `z-index: ${$zIndex}` : '')};
`;
